<template>
  <div class="newPatient-container">
    <div class="container">
      <el-card class="main-container">
        <div class="main-header">
           <div class="main-header-left">
             <span>{{$t('newP')}}</span>
            </div>
           <div class="main-header-right" :class="{'de22':isDe||isFr,'cz22':isCz}">
             <img src="../assets/back.png">
             <p  @click="back">{{$t('home')}}</p>
           </div>
        </div>
        <hr class="small-hr">
        <div class="item-wrap">
          <div class="item">
            <span :class="{'es2':isIt||isDe||isEs||isPo||isDu||isSw}">{{$t('fullName')}}</span>
            <input class="name" v-model="realname">
          </div>

          <div class="item">
            <span>{{$t('gender')}}</span>
            <select class="gender" v-model="gender" id="gender">
              <option value="GDRNF">{{$t('GDRNF')}}</option>
               <option value="GDRM">{{$t('GDRM')}}</option><option value="GDRF">{{$t('GDRF')}}</option>
            </select>
          </div>
          <div class="item">
            <span>{{$t('height')}}</span>
            <input v-model="height" class="height">
            <span class="unit">{{$t('cm')}}</span>
        </div>
          <div class="item">
            <span>{{$t('weight')}}</span>
            <input v-model="weight" class="height">
            <span class="unit">{{$t('kg')}}</span>
         </div>
          <div class="item spe-item">
            <span :class="{'es2':isEs||isIt||isPo||isFr||isCz}">{{$t('birthday')}}</span>
            <div class="block">
              <el-date-picker v-model="birthday"   type="date"  :placeholder="Time"
                              :clearable=false    :picker-options="pickerOptions" format="dd/MM  yyyy">
              </el-date-picker>
            </div>
          </div>
          <div class="item">
            <label class="spe-span">{{$t('disType')}}</label>
            <select class="weight" v-model="diabetes_type"  id="dis_type">
              <option value="DBTNF">{{$t('DBTNF')}}</option>
              <option selected value="DBT1">{{$t('Type 1')}}</option><option value="DBT2">{{$t('Type 2')}}</option>
              <option value="DBTLADA">{{$t('LADA')}}</option><option value="DBTGEST">{{$t('Gestational')}}</option>
              <option  value="DBTPRE">{{$t('DBTPRE')}}</option><option value="MODY">{{$t('MODY')}}</option>
            </select>
          </div>
          <div class="item">
            <label class="spe-span">{{$t('disDate')}}</label>
            <div class="block">
              <el-date-picker v-model="diabetes_diagnosis_date"  type="date" :placeholder="Time"
                              :clearable=false    :picker-options="pickerOptions" format="dd/MM  yyyy">
              </el-date-picker>
            </div>
          </div>

          <div class="item"><span class="addSpan">{{$t('Address')}}</span>
            <input class="address" v-model="address1"><input class="address" v-model="address2"></div>

          <div class="item post"><span>{{$t('Postcode')}}</span><input class="name" v-model="postcode"></div>
          <div class="item"><span>{{$t('Mobile')}}</span><input class="name" v-model="mobile"></div>
          <div class="item"><span >{{$t('Telephone')}}</span><input class="name" v-model="telephone"></div>
          <div class="item email"><span >{{$t('Email')}}</span><input class="name" v-model="email"></div>
        </div>
        <hr class="small-hr">
        <div class="footer">
          <div class="item1">
            <span :class="{'es1':isEs||isDe||isPo||isCz}">{{$t('Inpatient')}}</span>
            <select v-model="inpatient">
              <option>{{$t('Yes')}}</option><option>{{$t('No')}}</option>
            </select>
          </div>
          <div class="item1"><span :class="{'po1':isPo||isCz}">{{$t('Pno')}}</span><input v-model="patient_no"></div>
          <div class="item1 spe-item1"><span :class="{'po1':isPo||isCz}">{{$t('Bno')}}</span><input v-model="bed_no"></div>
        </div>
        <div class="operate">
          <button class="cancel" @click="back">{{$t('Cancel')}}</button>
           <button class="create" @click="create">{{$t('create')}}</button>
        </div>
      </el-card>
      <div class="Hcp-footer">
      <span>
<!--        <a href="http://www.medtrum.com/index.php/abouts">{{ $t('contact us') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
                      <a :href="contactURL">{{ $t('contact us') }} </a>
              <a :href="privacyURL">|  {{ $t('Privacy Policy') }} </a>
              <a :href="termsOfUseURL">|  {{ $t('Terms of Use') }} | </a>

        {{$t('copyright')}}<br/>
          <a v-show="isZh" target=_blank href="http://beian.miit.gov.cn/"> 沪ICP备08013753号-3  </a>
          <img v-show="isZh" src="/static/beian.png" />
          <a v-show="isZh" target=_blank href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"> 沪公网安备 31011502014155号 </a>
      </span>
      </div>
    </div>
  </div>
</template>

<script>
  import auth from '../auth/auth'
import format from '@/lib/format'
  export default{
    data(){
      return{
        realname:'',gender:'',height:'',weight:'',isEs:false,isDe:false,Time:this.$t('time'),
        birthday:'', diabetes_type:'',diabetes_diagnosis_date:'',
        address1:'', address2:'', postcode:'', mobile:'', telephone:'', email:'',isIt:false,isPo:false,isCz:false,
        inpatient:'', patient_no:'', bed_no:'',isDu:false,isFr:false,   isZh:false,isSw:false, isEU:true,
        pickerOptions:{
          disabledDate(time){
            return time.getTime()>Date.now();
          }
        },
        contactURL:'',
        privacyURL:'',
        termsOfUseURL:'',
      }
    },
    vuerify: {
      mobile:'mobile',
      height:'height',
      weight:'weight',
      email: 'email',
    },
    methods:{
      back(){
        this.$router.push('/PatientList');
      },
      create(){
        let bthday = (this.birthday)?format.formatterDate3(this.birthday.getTime()/1000):'';
        let diagnosis_date = (this.diabetes_diagnosis_date)?format.formatterDate3(this.diabetes_diagnosis_date.getTime()/1000):'';
        const obj1 =document.getElementById('dis_type');
        let dis_type = obj1.value;
        if(!dis_type){
          dis_type ="DBTNF";
        }
        const obj2 =document.getElementById('gender');
        let gender = obj2.value;
        if(!gender){
            gender ="GDRNF";
        }
        let info = {
          realname:this.realname,
          gender:gender,
          height:this.height,
          weight:this.weight,
          birthday:bthday,
          diabetes_type:dis_type,
          diabetes_diagonosis_date:diagnosis_date,
          address:this.address1+this.address2,     postcode:this.postcode,
          mobile:this.mobile,        telephone:this.telephone,   email:this.email,
          inHospital:this.inpatient,
          patientNo:this.patient_no,
          bedNo:this.bed_no,
        };
       // console.log(info)
         if(this.realname===''){
            let tip = this.$t('A name is required');
            this.$message.error(tip);
         }else{
             this.$http.post('api/v2.0/patients/new',{'info':info}).then(function (res) {
               let err =res.body.error;
               if(err === 0){
                 this.$message({
                   type: 'success',
                   message: 'Created sucessfully'
                 });
                 this.$router.push('/PatientList');
               }else{
                    this.$message.error('Create failed');
                   }
             },function(err){
               console.log(err+","+err.body.message);
               this.error = err.body.message
             })
         }
      }
    },
    mounted(){
      let lang = sessionStorage.getItem('language');
      this.isEs= (lang==='es')?true:false;
      this.isDe= (lang==='de')?true:false;
      this.isIt= (lang==='it')?true:false;
      this.isPo= (lang==='po')?true:false;
      this.isDu= (lang==='du')?true:false;
      this.isFr= (lang==='fr')?true:false;
      this.isZh = (lang==='zh')?true:false;
      this.isSw = (lang==='sw')?true:false;
      this.isCz = (lang==='cz')?true:false;
      let countryIndex=localStorage.getItem('index');
      //console.info('countryIndex:'+countryIndex);
      if (1==countryIndex || 6==countryIndex || 14==countryIndex) {
        this.isEU=false;
      }
      setTimeout(()=>{
        let host=auth.getOuterHost();
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }, 50)
    }
  }
</script>
<style scoped>
  .newPatient-container{
    *height:100%;
    width:100%;
    background-color:#fff;
  }
  .container{
    width:62%;
    height: 969px;
    margin:0 auto;
    background:#fafbfc;
    padding-top: 15px;
  }
  @media screen and (max-width: 1500px){
    .container{
      width:92%;
    }
  }
  .main-container{
    width:97%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header{
    width: 98%;
    margin:0 auto;
    height:20px;
    margin-bottom: 15px;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-right{
    float: right;
    width:70px;
    height:20px;
    line-height: 20px;
    margin-right: 1%;
  }
  .de22{
    width:90px;
  }
  .cz22{
    width:80px;
  }
  .main-header-right img{
    display: block;
    margin-top: 5px;
    float: left;
  }
  .main-header-right p{
    float:right;
    color:#0082d2;
    margin-top: 2px;
    cursor: pointer;
  }
  .small-hr{
    background:#e6e8ea;
    width:98%;
    height:1px;
    margin:0 auto 15px;
    border:none;
  }

  .item-wrap{
    width:96%;
    margin:0 auto;
  }
  .item{
    width:95%;
    height:37px;
    line-height: 37px;
    margin-bottom: 15px;
  }
  .item span{
    width:100px;
    height: 100%;
    float: left;
    display: inline-block;
  }
  .ID{
    color:#0082d2;
    margin-left: 40px;
  }
  .item .name{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:298px;
    height:35px;
    font-size:18px;
    margin-left: 40px;
    padding-left:8px;
    color:#282828;
    font-family:SFUIText-Regular;
  }
  .item select{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:152px;
    height:35px;
    font-size:18px;
    margin-left: 40px;
    color:#282828;
    padding-left: 6px;
    font-family:SFUIText-Regular;
  }
  .item option{
    color: #282828;
    font-family:SFUIText-Regular;
  }
  .item .height{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:144px;
    height:34px;
    font-size:16px;
    margin-left: 40px;
    color:#282828;
    padding-left: 6px;
    font-family:SFUIText-Regular;
  }
  .item .spe-span{
    height:20px;
    line-height: 20px;
    width:80px;
    display: block;
    float: left;
    margin-right: 20px;
  }
  .item .addSpan{
    height:60px;
  }
  .item .address{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:60%;
    height:35px;
    margin-left: 40px;
    margin-bottom: 12px;
    padding-left: 8px;
    color:#282828;
    font-size: 16px;
    font-family:SFUIText-Regular;
  }
  .post{
    clear: both;
    margin-top: 65px;
  }
  .email{
    margin-bottom: 30px;
  }
  .item .unit{
    float:none;
    margin-left: 4px;
    font-size: 18px;
  }
  .item .es2{
    width:100px;
    height: 20px;
    line-height: 20px;
    float: left;
    display: inline-block;
    margin:0;
  }
  .item .block{
    margin-left: 40px;
    float: left;
  }
  .el-date-editor.el-input{
    width:152px;
    color:#282828;
  }


  .footer{
    width:96%;
    margin:0 auto;
    margin-bottom: 60px;
  }
  .item1{
    float: left;
    width:30%;
    margin-right: 4%;
  }
  .item1 select,.item1 input{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:45%;
    height:35px;
    margin-left: 20%;
    padding-left: 6px;
    color:#282828;
    font-family:SFUIText-Regular;
    font-size: 16px;
  }
  .item1 input{
    width:50%;
    margin-left: 5%;
    padding-left: 8px;
  }
  .spe-item1{
    margin-right: 0;
  }
  .es1{
    width:50px;
    float: left;
  }
  .po1{
    width:90px;
    float: left;
  }

  .operate{
    width: 50%;
    float: right;
    margin-top:50px;
    margin-bottom: 20px;
    margin-right: 10px;
  }
  .operate button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    border-radius:100px;
    width:150px;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
    float: right;
  }
  .operate .create{
    margin-right: 20px;
  }
  .operate .cancel{
    background: transparent;
    border:1px solid #a3a3a3;
  }

  .Hcp-footer{
    font-family:HelveticaNeue;
    font-size:14px;
    color:rgba(120,120,120,0.90);
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 13px;
    margin-bottom: 10px;
  }
  .Hcp-footer a{
    color:rgba(120,120,120,0.90);
    text-decoration: none;
  }
  .Hcp-footer a:hover{
    color:#0090D3;
  }
</style>



// WEBPACK FOOTER //
// newPatient.vue?c5df959a